import { InputAdornment, IconButton, Paper, TextField, Typography } from "@mui/material";
import React from "react";
import CancelIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { useUser } from "../../requests/users";

export type AddOrEditCommentProps = {
  onClose: () => void;
  onSubmit: () => void;
  addOrEditContent: string | null;
  setAddOrEditContent: (content: string | null) => void;
  inputRef: React.RefObject<HTMLInputElement>;
};

export const AddOrEditComment = ({
  onClose,
  onSubmit,
  addOrEditContent,
  setAddOrEditContent,
  inputRef,
}: AddOrEditCommentProps) => {
  const user = useUser();
  return (
    <Paper
      elevation={3}
      sx={{
        m: 1,
        p: "0.5em",
        position: "relative",
      }}
    >
      <Typography variant="subtitle2" color="primary">
        {user?.name}
      </Typography>
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{
          position: "absolute",
          top: "0.8em",
          right: "0.8em",
        }}
      >
        <IconButton sx={{ p: "2px", mb: "2px" }} onClick={onClose}>
          <CancelIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Typography>
      <TextField
        inputRef={inputRef}
        value={addOrEditContent}
        onChange={(e) => setAddOrEditContent(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
          }
        }}
        placeholder="Comment"
        autoFocus
        multiline
        maxRows={3}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={onSubmit} color="primary">
                <SendIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderWidth: 1,
            },
          },
        }}
      />
    </Paper>
  );
};
